/**
 * Created by sswaminathan on 2/4/22
 * File: Units
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Body } from '@panwds/react-ui'
/**
 *   TODO: Brief what is this component/class do
 */

const Units = ({ units }) => {

  return <Body size="md" addClassName='tw-pt-5 tw-ml-4' appearance="secondary">{units}</Body>
}

Units.propTypes = {}
export default Units
